"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const js_1 = __importDefault(require("@honeybadger-io/js"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const applicants_1 = require("./applicants");
const eds_1 = require("./apply/eds");
const credit_application_1 = require("./credit_application");
const StoreLookup_1 = __importDefault(require("./credit_application/views/StoreLookup"));
const Layout_1 = __importDefault(require("./Layout"));
const prove_1 = require("./prove");
const receipt_1 = require("./receipt");
const Views = __importStar(require("./views"));
function Routes() {
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    (0, hooks_1.useButtonClickTracker)();
    (0, hooks_1.useRouteTracker)();
    (0, hooks_1.useNavigationTracker)();
    const consumerAppDown = process.env
        .REACT_APP_CONSUMER_DOWN_MESSAGE_ENABLED;
    async function setHoneybadgerContext() {
        let ip = '';
        try {
            const response = await fetch('https://api.ipify.org?format=json', {
                signal: AbortSignal.timeout(5000),
            });
            const data = await response.json();
            ip = data.ip;
        }
        catch {
            ip = 'unknown';
        }
        js_1.default.setContext({
            ipAddress: ip,
            hyperDxSessionId: (0, utils_1.getCookie)('__rum_sid'),
        });
    }
    (0, react_1.useEffect)(() => {
        setHoneybadgerContext();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Layout_1.default, { children: [consumerAppDown === true && (0, jsx_runtime_1.jsx)(Views.DownPage, {}), consumerAppDown !== true && ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: (0, config_1.makePath)(path, '/:credit_application_id/aff/provider_success'), children: (0, jsx_runtime_1.jsx)(Views.ProviderCallbackSuccess, { lender: "aff" }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, '/receipt/:receiptIdEncoded'), children: (0, jsx_runtime_1.jsx)(receipt_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: `${config_1.PATH.CREDIT_PORTAL}${config_1.PATH.CREDIT_APPLICATION}${config_1.PATH.EDS.BASE}`, exact: false, children: (0, jsx_runtime_1.jsx)(eds_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, config_1.PATH.CREDIT_APPLICATION), children: (0, jsx_runtime_1.jsx)(credit_application_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, config_1.PATH.APPLICANTS), children: (0, jsx_runtime_1.jsx)(applicants_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, '/store/:id'), exact: true, children: (0, jsx_runtime_1.jsx)(StoreLookup_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: (0, config_1.makePath)(path, config_1.PATH.PROVE?.BASE), exact: false, children: (0, jsx_runtime_1.jsx)(prove_1.Routes, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { path: "*", to: (0, config_1.makePath)(path, config_1.PATH.CREDIT_APPLICATION) })] }))] }));
}
exports.default = Routes;
